/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcolaudience2Inputs */

const en_channelcolaudience2 = /** @type {(inputs: Channelcolaudience2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audience`)
};

const de_channelcolaudience2 = /** @type {(inputs: Channelcolaudience2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe`)
};

/**
* | output |
* | --- |
* | "Audience" |
*
* @param {Channelcolaudience2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcolaudience2 = /** @type {((inputs?: Channelcolaudience2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcolaudience2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcolaudience2(inputs)
	return de_channelcolaudience2(inputs)
});
export { channelcolaudience2 as "channelColAudience" }